import { MutationCache, QueryClient } from "@tanstack/react-query";
import { describeError, toast } from "@hostdock/ui";
import { ApiClient, ApiError, createAdminApi } from "@hostdock/sdk";

export const SESSION_KEY = ["session"] as const;

export const queryClient = new QueryClient({
  // Any mutation that does not handle its own error still surfaces it: no admin action fails silently. Mutations that
  // set their own onError keep full control.
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.options.onError) return;
      // The form already shows this error inline (FormError, dialog error): a toast would only repeat it.
      if (mutation.meta?.inlineError) return;
      if (error instanceof ApiError && (error.code === "SESSION_EXPIRED" || error.code === "UNAUTHENTICATED")) return;
      const d = describeError(error);
      toast.error(d.title, { description: d.message });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      // Never retry auth/permission/validation failures.
      retry: (count, err) => !(err instanceof ApiError && err.status > 0 && err.status < 500) && count < 2,
    },
  },
});

export const client = new ApiClient({
  onUnauthenticated: (err) => {
    if (err.code === "SESSION_EXPIRED" || err.code === "UNAUTHENTICATED") queryClient.setQueryData(SESSION_KEY, null);
  },
});

export const api = createAdminApi(client);
